import { getUser } from "@utils";
import React from "react";
import { Content, ContentTitle } from "../baseItems";
import Base from "./base";

export default class MiniHavale extends Base {
	getStep1(translate) {
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				{this.getCurrencyField(translate)}
				{this.renderMinMax()}
			</Content>
		);
	}

	makeExternalPayment(newStep) {
		this.props.externalFunc.depositMinihavale(
			{
				//language: this.getActiveLanguageCode(),
				sessionId: getUser().sessionId,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		this.props.externalFunc.depositMinihavale(
			{
				//language: this.getActiveLanguageCode(),
				sessionId: getUser().sessionId,
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}
}
